import { z } from "zod"

export const formSchema = z
  .object({
    password: z
      .string()
      .length(4, "Secret pin is required")
      .regex(/[0-9]/, "Secret pin must be only numbers"),
    passwordConfirmation: z
      .string()
      .length(4, "Secret pin confirmation is required"),
    terms1: z.literal(true),
    terms2: z.literal(true),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: "Secrets do not match",
    path: ["passwordConfirmation"],
  })
